<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">

                    <el-select size="mini" v-model="formDatas.acoType" clearable @change="partserch"
                        placeholder="请选择类型" style="width: 130px">
                        <el-option label="更换" :value="2" key="2"></el-option>
                        <el-option label="新建" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-dropdown size="mini" split-button type="warning" style="margin:0 10px;" @click="Out()"
                        @command="Out">
                        导出
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="background-color: #E6A23C;color: white;"
                                command="1">导出全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> -->
                    <!-- <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增工装</el-button> -->

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="acoId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑工装' : '新增工装'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="工装名称" prop="acwName">
                                <el-input v-model="form.acwName" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="工装类型" prop="acwType">
                                <el-select v-model="form.acwType" placeholder="请选择">
                                    <el-option label="七件套" :value="1"></el-option>
                                    <el-option label="九件套" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="男女" prop="acwSex">
                                <el-select v-model="form.acwSex" placeholder="请选择">
                                    <el-option label="都适合" :value="0"></el-option>
                                    <el-option label="男" :value="1"></el-option>
                                    <el-option label="女" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="默认领取数量" prop="acwNum">
                                <el-input v-model="form.acwNum" type="number" style="width: 50%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="描述" prop="acwDes">
                                <el-input v-model="form.acwDes" style="width: 100%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="图片" prop="acwImages">
                                <my-upload ref="Imgupload" @fileChange="fileChange" :filearr="fileList"
                                    @removeAfter="removeAfter" :limit="9" style="margin: 10px 5px 5px;">
                                </my-upload>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh" :close-on-click-modal="false"
                :before-close="partserch">
                <div style="height: 700px; overflow-y: auto">
                    <el-descriptions :column="3" border :labelStyle="{
                        color: '#409EFF',
                        textAlign: 'center',
                        width: '14%',
                        fontSize: '12px'
                    }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                        <el-descriptions-item label="订单标题">{{ DetailArr.acoTitle }}</el-descriptions-item>
                        <el-descriptions-item label="订单日期">{{ DetailArr.acoDate }}</el-descriptions-item>
                        <el-descriptions-item label="人数">{{ DetailArr.acoApplyNum }}</el-descriptions-item>
                        <el-descriptions-item label="员工">{{ DetailArr.acoApplyUsers }}</el-descriptions-item>
                        <el-descriptions-item label="工装类型">
                            <el-tag size="mini">{{ DetailArr.acoType == 1 ? '新建' : DetailArr.acoType == 2 ? '更换' :
                        '内部交换'
                                }}</el-tag>
                        </el-descriptions-item>
                    </el-descriptions>
                    <div style="margin: 10px 20px;">订购工装员工</div>
                    <div style="width: 100%;height:200px;">
                        <ve-table ref="vetable" v-if="DetailArr && DetailArr.ajClothesApplyList.length > 0"
                            :columns="columnsUser" :table-data="DetailArr.ajClothesApplyList" :max-height="200"
                            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                            :checkbox-option="checkboxOption" row-key-field-name="dataIndex"
                            :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                        <div v-show="DetailArr.ajClothesApplyList && DetailArr.ajClothesApplyList.length == 0"
                            class="empty-data">
                            暂无订购工装员工</div>
                    </div>
                    <div style="margin: 10px 20px;">工装</div>
                    <div style="width: 100%;height:200px;">
                        <ve-table ref="vetable" v-if="DetailArr && DetailArr.ajClothesApplyItemList.length > 0"
                            :columns="columnsUserItem" :table-data="DetailArr.ajClothesApplyItemList" :max-height="200"
                            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                            :checkbox-option="checkboxOption" row-key-field-name="dataIndex"
                            :cell-span-option="cellSpanOption" :cellSelectionOption="cellSelectionOption"
                            style="width: 100%" :editOption="editOption" />
                        <div v-show="DetailArr.ajClothesApplyItemList && DetailArr.ajClothesApplyItemList.length == 0"
                            class="empty-data">
                            暂无工装规格</div>
                    </div>
                </div>
            </el-dialog>
            <!-- 采购 -->
            <el-dialog title="采购" :visible.sync="IsPurchase" width="70%" top="8vh">
                <el-form ref="PForm" :model="PForm" label-position="top" :rules="rules" style="height:100%">
                    <el-form-item label="购买日期" prop="acoBuyDate">
                        <el-date-picker v-model="PForm.acoBuyDate" type="date" value-format="yyyy-MM-dd"
                            placeholder="选择日期" style="width: 200px;">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="快递单号" prop="acoBuyNum">
                        <el-input v-model="PForm.acoBuyNum" style="width: 200px;" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="购买描述" prop="acoBuyDes">
                        <el-input v-model="PForm.acoBuyDes" style="width: 200px;" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleWorkPurchaseClose">取 消</el-button>
                    <el-button type="primary" @click="sureworkPurchase">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 到货 -->
            <el-dialog title="到货" :visible.sync="IsDeliver" width="70%" top="8vh">
                <el-form ref="DForm" :model="DForm" label-position="top" :rules="rules" style="height:100%">
                    <el-form-item label="到货日期" prop="acoArrivalDate">
                        <el-date-picker v-model="DForm.acoArrivalDate" type="date" value-format="yyyy-MM-dd"
                            placeholder="选择日期" style="width: 200px;">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleWorkDeliverClose">取 消</el-button>
                    <el-button type="primary" @click="sureworkDeliver">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 领取 -->
            <el-dialog title="领取" :visible.sync="isUserDetail" width="70%" top="8vh">
                <ve-table ref="vetable" v-if="userDetail && userDetail.ajClothesApplyItemList" :columns="UserTable"
                    :table-data="userDetail.ajClothesApplyItemList" :max-height="500" :border-x="true" :border-y="true"
                    :scrollWidth="10" :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                    row-key-field-name="dataIndex" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                    :editOption="editOption" />
                <div v-show="userDetail && userDetail.ajClothesApplyItemList && userDetail.ajClothesApplyItemList.length == 0"
                    class="empty-data">
                    暂无订购工装员工</div>
            </el-dialog>
            <!-- 换货 -->
            <el-dialog title="换货" :visible.sync="isReturn" width="70%" top="8vh">
                <el-select v-model="GgAcwsId" placeholder="请选择规格" filterablesize="mini">
                    <el-option v-for="item in workGgArr || []" :label="item.acwsName" :value="item.acwsId"
                        :key="item.acwsId">
                    </el-option>
                </el-select>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleWorkReturnClose">取 消</el-button>
                    <el-button type="primary" @click="sureWorkReturn">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 预生成订单 -->
            <el-dialog title="订单" :visible.sync="IsOrder" width="70%" top="8vh">
                <div v-if="OrderList.ajClothesApplyItemList && OrderList.ajClothesApplyItemList.length > 0"
                    style="margin: 10px;" class="OrderDia">
                    <el-card>
                        <el-form ref="formDD" :model="formDD" label-position="left" label-width="150px"
                            @submit.native.prevent style="display: flex;align-items: center;">
                            <div style="width: 50%;">
                                <el-form-item label="订单标题" prop="acoTitle">
                                    <el-input v-model="formDD.acoTitle" style="width: 90%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                            </div>
                            <div style="width: 50%;">
                                <el-form-item label="订单日期" prop="acoDate">
                                    <el-date-picker v-model="formDD.acoDate" type="date" value-format="yyyy-MM-dd"
                                        placeholder="选择日期" style="width: 200px;">
                                    </el-date-picker>
                                </el-form-item>
                            </div>

                        </el-form>
                    </el-card>

                </div>
                <ve-table ref="vetable"
                    v-if="OrderList.ajClothesApplyItemList && OrderList.ajClothesApplyItemList.length > 0"
                    :columns="columnsDD" :table-data="OrderList.ajClothesApplyItemList" :max-height="200"
                    :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                    :checkbox-option="checkboxOption" row-key-field-name="acaiId"
                    :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                <div v-show="OrderList.ajClothesApplyItemList && OrderList.ajClothesApplyItemList.length == 0"
                    class="empty-data">
                    暂无工装</div>

                <div>
                    <el-row>
                        <el-col :span="12">
                            <div style="margin: 5px;">换货明细</div>
                        </el-col>
                        <el-col :span="12">
                            <div style="margin: 5px;display: flex;flex-direction: row-reverse;">
                                <el-button type="success" @click="OneKeyExchange" size="mini">一键交换</el-button>
                            </div>
                        </el-col>
                    </el-row>
                    <ve-table ref="vetable"
                        v-if="OrderList.ajClothesApplyItemDetailsList && OrderList.ajClothesApplyItemDetailsList.length > 0"
                        :columns="columnsMX" :table-data="OrderList.ajClothesApplyItemDetailsList" :max-height="300"
                        :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                        :checkbox-option="checkboxOption2" row-key-field-name="acaiId"
                        :cellSelectionOption="cellSelectionOption2" style="width: 100%" :editOption="editOption" />
                    <div v-show="OrderList.ajClothesApplyItemDetailsList && OrderList.ajClothesApplyItemDetailsList.length == 0"
                        class="empty-data">
                        暂无工装</div>
                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleWorkDDClose">取 消</el-button>
                    <el-button type="primary" @click="sureworkDD">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 领取明细 -->
            <el-dialog title="领取明细" :visible.sync="IsReceive" width="80%" top="8vh">
                <ve-table ref="vetable" v-if="ReceiveData.length > 0" :columns="ReceiveDataTable"
                    :table-data="ReceiveData" :max-height="500" :border-x="true" :border-y="true" :scrollWidth="10"
                    :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="acaiId"
                    :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                <div v-show="ReceiveData && ReceiveData.length == 0" class="empty-data">
                    暂无明细</div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleReceiveClose">取 消</el-button>
                    <el-button type="primary" @click="ReceiveExport">确定导出</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    getAjClothesOrderItemDetails,
    updateAjClothesApplyItemExchange, getAjClothesWareScaleList, getAjClothesOrderPreconditioningExchange, addAjClothesOrderExchange, updateAjClothesApplyItemExchangeInside,
    getAjClothesOrderList, getAjClothesOrderDetails, updateAjClothesOrderToBuy, updateAjClothesOrderArrival, updateAjClothesApplyItemReceive, getAjClothesApplyDetails
} from "../../api/api";
import { color } from 'echarts';
export default {
    name: "",
    components: {},
    data() {
        return {
            ReceiveDataTable: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    fixed: 'left',
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "姓名",
                    fixed: 'left',
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "auSex",
                    key: "auSex",
                    title: "性别",
                    align: "center",
                    width: 80,
                    edit: false,
                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "部门",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "auClothesType",
                    key: "auClothesType",
                    title: "工装类型",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag>{row.auClothesType == 1 ? '七件套' : '九件套'}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "acwName",
                    key: "acwName",
                    title: "工装",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acwsName",
                    key: "acwsName",
                    title: "规格",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acaiNum",
                    key: "acaiNum",
                    title: "总数",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acaiChildAcwsName",
                    key: "acaiChildAcwsName",
                    title: "子级工装规格",
                    align: "center",
                    width: 90,
                    edit: false,
                },
                {
                    field: "acaiChildStatus",
                    key: "acaiChildStatus",
                    title: "子级状态",
                    align: "center",
                    width: 80,
                    edit: false,
                },
                {
                    field: "acaiChildDes",
                    key: "acaiChildDes",
                    title: "内部交换描述",
                    align: "center",
                    width: 200,
                    edit: false,
                },
                {
                    field: "acaiType",
                    key: "acaiType",
                    title: "类型",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.acaiType == 2 ? (
                                    <el-tag size="mini" type="danger">
                                        更换
                                    </el-tag>
                                ) : row.acaiType == 1 ? (
                                    <el-tag size="mini" type="primary">
                                        新建
                                    </el-tag>
                                ) : (
                                    <el-tag size="mini" type="warming">
                                        内部交换
                                    </el-tag>
                                )}
                            </span>
                        )
                    },
                },
                {
                    field: "acaiStatus",
                    key: "acaiStatus",
                    title: "状态",
                    align: "center",
                    fixed: 'right',
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.acaiStatus == 1 ? (
                                    <el-tag size="mini" type="danger">
                                        待采购
                                    </el-tag>
                                ) : row.acaiStatus == 2 ? (
                                    <el-tag size="mini" type="primary">
                                        采购中
                                    </el-tag>
                                ) : row.acaiStatus == 3 ? (
                                    <el-tag size="mini" type="warning">
                                        待领取
                                    </el-tag>
                                ) : row.acaiStatus == 4 ? (
                                    <el-tag size="mini" type="success">
                                        已领取
                                    </el-tag>
                                ) : (
                                    <el-tag size="mini" type="info">
                                        换货
                                    </el-tag>
                                )}
                            </span>
                        )
                    },
                },
            ],
            ReceiveData: [],
            IsReceive: false,
            spanNum: [],
            spanValue: [],
            cellSpanOption: {
                bodyCellSpan: this.bodyCellSpan,
            },
            columnsMX: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "姓名",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "auSex",
                    key: "auSex",
                    title: "性别",
                    align: "center",
                    width: 80,
                    edit: false,
                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "部门",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "auClothesType",
                    key: "auClothesType",
                    title: "工装类型",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag>{row.auClothesType == 1 ? '七件套' : '九件套'}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "acwName",
                    key: "acwName",
                    title: "工装名称",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acaiParentAcwsName",
                    key: "acaiParentAcwsName",
                    title: "换前",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <span style={{ color: row.exchangeSign ? row.exchangeSignColor : 'black' }} >
                                        {row.acwsIdExchangeStatus == 1 ? row.acaiParentAcwsName : (row.acaiParentAcwsName + '(已更换)')}
                                    </span>
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "acwsName",
                    key: "acwsName",
                    title: "换后",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <span style={{ color: row.exchangeSign ? row.exchangeSignColor : 'black' }} >{row.acwsName}</span>
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "acaiNum",
                    key: "acaiNum",
                    title: "数量",
                    align: "center",
                    width: 100,
                    edit: false,
                },

            ],
            columnsDD: [

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acwName",
                    key: "acwName",
                    title: "工装名称",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acwsName",
                    key: "acwsName",
                    title: "规格",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acaiNumTotal",
                    key: "acaiNumTotal",
                    title: "数量",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                // { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                // {
                //     field: "",
                //     key: "d",
                //     title: "操作",
                //     width: 200,
                //     align: "center",
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span>
                //                 <el-button
                //                     size="mini"
                //                     type="text"
                //                     on-click={() => this.handleWorkGgEdit(row)}
                //                 >
                //                     编辑
                //                 </el-button>
                //                 <el-button
                //                     size="mini"
                //                     type="text"
                //                     style="color: red"
                //                     on-click={() => this.handleWorkGgDelete(row)}
                //                 >
                //                     删除
                //                 </el-button>
                //             </span>
                //         );
                //     },
                // },
            ],
            IsOrder: false,
            OrderList: [],
            formDD: {
                acoId: '',
                acoTitle: '',
                acoDate: '',
            },
            isReturn: false,

            RForm: {
                acaiId: '',
            },
            GgAcwsId: '',
            workGgArr: [{
                acwsId: 0,
                acwsName: "不需要",
            }],
            UserTable: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acwName",
                    key: "acwName",
                    title: "工装",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acwsName",
                    key: "acwsName",
                    title: "规格",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acaiNum",
                    key: "acaiNum",
                    title: "总数",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acaiChildAcwsName",
                    key: "acaiChildAcwsName",
                    title: "子级工装规格",
                    align: "center",
                    width: 90,
                    edit: false,
                },
                {
                    field: "acaiChildStatus",
                    key: "acaiChildStatus",
                    title: "子级状态",
                    align: "center",
                    width: 80,
                    edit: false,
                },
                {
                    field: "acaiChildDes",
                    key: "acaiChildDes",
                    title: "内部交换描述",
                    align: "center",
                    width: 200,
                    edit: false,
                },
                {
                    field: "acaiType",
                    key: "acaiType",
                    title: "类型",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.acaiType == 2 ? (
                                    <el-tag size="mini" type="danger">
                                        更换
                                    </el-tag>
                                ) : row.acaiType == 1 ? (
                                    <el-tag size="mini" type="primary">
                                        新建
                                    </el-tag>
                                ) : (
                                    <el-tag size="mini" type="warming">
                                        内部交换
                                    </el-tag>
                                )}
                            </span>
                        )
                    },
                },
                {
                    field: "acaiStatus",
                    key: "acaiStatus",
                    title: "状态",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.acaiStatus == 1 ? (
                                    <el-tag size="mini" type="danger">
                                        待采购
                                    </el-tag>
                                ) : row.acaiStatus == 2 ? (
                                    <el-tag size="mini" type="primary">
                                        采购中
                                    </el-tag>
                                ) : row.acaiStatus == 3 ? (
                                    <el-tag size="mini" type="warning">
                                        待领取
                                    </el-tag>
                                ) : row.acaiStatus == 4 ? (
                                    <el-tag size="mini" type="success">
                                        已领取
                                    </el-tag>
                                ) : (
                                    <el-tag size="mini" type="info">
                                        换货
                                    </el-tag>
                                )}
                            </span>
                        )
                    },
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 70,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.acaiStatus == 3 ? <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.ReceiveClick(row)}
                                    >
                                        领取
                                    </el-button> : ''
                                }
                                {
                                    row.acaiStatus == 4 && row.acaiType == 1 ? <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.returnClick(row)}
                                    >
                                        换货
                                    </el-button> : ''
                                }
                            </span>
                        );
                    },
                },
            ],
            userDetail: [],
            userForm: {
                acaId: '',
                acoId: '',
            },
            isUserDetail: false,
            IsDeliver: false,
            DForm: {
                acoId: '',
                acoArrivalDate: '',
            },
            IsPurchase: false,
            PForm: {
                acoId: '',
                acoBuyDate: '',
                acoBuyNum: '',
                acoBuyDes: '',
            },
            workEdit: false,
            formGg: {
                acwId: '',
                acwsName: '',
            },
            WorkGgShow: false,
            workClothesGg: [],
            columnsUserItem: [

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acwName",
                    key: "acwName",
                    title: "工装",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acwsName",
                    key: "acwsName",
                    title: "规格",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "acaiNumTotal",
                    key: "acaiNumTotal",
                    title: "总数",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                // {
                //     field: "",
                //     key: "d",
                //     title: "操作",
                //     width: 200,
                //     align: "center",
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span>
                //                 <el-button
                //                     size="mini"
                //                     type="text"
                //                     on-click={() => this.handleWorkGgEdit(row)}
                //                 >
                //                     编辑
                //                 </el-button>
                //                 <el-button
                //                     size="mini"
                //                     type="text"
                //                     style="color: red"
                //                     on-click={() => this.handleWorkGgDelete(row)}
                //                 >
                //                     删除
                //                 </el-button>
                //             </span>
                //         );
                //     },
                // },
            ],
            columnsUser: [

                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "姓名",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.getUserDetail(row)}
                                >
                                    {row.auName}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "auSex",
                    key: "auSex",
                    title: "性别",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "auDepartment",
                    key: "auDepartment",
                    title: "部门",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "auClothesType",
                    key: "auClothesType",
                    title: "工装类型",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag>{row.auClothesType == 1 ? '七件套' : '九件套'}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "acaStatus",
                    key: "acaStatus",
                    title: "状态",
                    align: "center",
                    width: 100,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.acaStatus == 1 ? (
                                    <el-tag size="mini" type="danger">
                                        待采购
                                    </el-tag>
                                ) : row.acaStatus == 2 ? (
                                    <el-tag size="mini" type="primary">
                                        采购中
                                    </el-tag>
                                ) : row.acaStatus == 3 ? (
                                    <el-tag size="mini" type="warning">
                                        待领取
                                    </el-tag>
                                ) : row.acaStatus == 4 ? (
                                    <el-tag size="mini" type="success">
                                        已领取
                                    </el-tag>
                                ) : (
                                    <el-tag size="mini" type="info">
                                        换货
                                    </el-tag>
                                )}
                            </span>
                        )
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                // {
                //     field: "",
                //     key: "d",
                //     title: "操作",
                //     width: 200,
                //     align: "center",
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         return (
                //             <span>
                //                 <el-button
                //                     size="mini"
                //                     type="text"
                //                     on-click={() => this.handleWorkGgEdit(row)}
                //                 >
                //                     编辑
                //                 </el-button>
                //                 <el-button
                //                     size="mini"
                //                     type="text"
                //                     style="color: red"
                //                     on-click={() => this.handleWorkGgDelete(row)}
                //                 >
                //                     删除
                //                 </el-button>
                //             </span>
                //         );
                //     },
                // },
            ],
            DetailArr: '',
            acwId: '',
            IsDetail: false,
            fileList: [],
            key: 'acwId',
            dialog: false,
            edit: false,
            form: {
                acwType: '',
                acwName: '',
                acwSex: '',
                acwNum: '',
                acwDes: '',
                acwImages: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            cellSelectionOption2: {
                // disble cell selection
                enable: true,
            },
            disabled_arr: [],
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            selectedRowKeysCollection2: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            checkboxOption2: {
                // 可控属性
                disableSelectedRowKeys: [],
                hideSelectAll: true,
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys2(row, isSelected, 'acaiId');
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, 'acaiId');
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    fixed: 'left',
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acoTitle",
                    key: "acoTitle",
                    title: "订单标题",
                    fixed: 'left',
                    align: "center",
                    width: 200,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.getDetail(row.acoId)}
                                >
                                    {row.acoTitle}
                                </el-button>

                            </span>
                        );
                    },
                },

                {
                    field: "acoDate",
                    key: "acoDate",
                    title: "订单日期",
                    align: "center",
                    width: 80,
                    edit: false,
                },
                {
                    field: "acoApplyNum",
                    key: "acoApplyNum",
                    title: "人数",
                    align: "center",
                    width: 80,
                    edit: false,
                },
                {
                    field: "acoApplyUsers",
                    key: "acoApplyUsers",
                    title: "员工",
                    align: "center",
                    width: 200,
                    edit: false,
                },

                {
                    field: "acoType",
                    key: "acoType",
                    title: "类型",
                    align: "center",
                    width: 80,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.acoType == 2 ? (
                                        <el-tag size="mini" type="danger">
                                            更换
                                        </el-tag>
                                    ) : row.acoType == 1 ? (
                                        <el-tag size="mini" type="primary">
                                            新建
                                        </el-tag>
                                    ) : (
                                        <el-tag size="mini" type="warming">
                                            内部交换
                                        </el-tag>
                                    )
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "acoStatus",
                    key: "acoStatus",
                    title: "订单状态",
                    align: "center",
                    width: 80,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.acoStatus == 1 ? (
                                    <el-tag size="mini" type="danger">
                                        新建
                                    </el-tag>
                                ) : row.acoStatus == 2 ? (
                                    <el-tag size="mini" type="primary">
                                        已购买
                                    </el-tag>
                                ) : row.acoStatus == 3 ? (
                                    <el-tag size="mini" type="success">
                                        已到货
                                    </el-tag>
                                ) : (
                                    <el-tag size="mini" type="info">
                                        已领取
                                    </el-tag>
                                )}
                            </span>
                        )
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 140, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 280,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.acoStatus == 1 ? <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.purchaseClick(row)}
                                    >
                                        采购
                                    </el-button> : ''
                                }
                                {
                                    row.acoStatus == 2 ? <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.deliverClick(row)}
                                    >
                                        到货
                                    </el-button> : ''
                                }
                                {
                                    row.acoStatusExchange == 2 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.ReturnLook(row)}
                                    >
                                        换货查看
                                    </el-button> : ''
                                }
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.batchExcel(row)}
                                    >
                                        导出统计
                                    </el-button>
                                }
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.batchExcelItems(row)}
                                    >
                                        导出明细
                                    </el-button>
                                }
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.ReceiveDetails(row)}
                                    >
                                        领取明细
                                    </el-button>
                                }

                            </span>
                        );
                    },
                },
            ], //表格的列
            acoId: '',
            tableData: [],
            post: null,
            formDatas: {
                acwName: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        ReceiveExport() {
            this.openLoading()
            var s = qs.stringify({ acoId: this.acoId });
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL2 + '/aj-clothes-order/exportAjClothesOrderItemDetails',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('userid'),
                }
            }).then(function (res) {
                if (res.data) {
                    const decodedString = decodeURIComponent(res.headers.filename);
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", decodedString);
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        ReceiveDetails(row) {
            this.acoId = row.acoId
            getAjClothesOrderItemDetails({ acoId: row.acoId }).then(res => {
                this.ReceiveData = res.data;
                this.IsReceive = true;
            })
        },
        // 导出
        batchExcel(row) {
            this.openLoading()
            var s = qs.stringify({ acoId: row.acoId });
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL2 + '/aj-clothes-order/exportAjClothesOrder',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('userid'),
                }
            }).then(function (res) {
                if (res.data) {
                    const decodedString = decodeURIComponent(res.headers.filename);
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", decodedString);
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        batchExcelItems(row) {
            this.openLoading()
            var s = qs.stringify({ acoId: row.acoId });
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL2 + '/aj-clothes-order/exportAjClothesOrderItems',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('userid'),
                }
            }).then(function (res) {
                if (res.data) {
                    const decodedString = decodeURIComponent(res.headers.filename);
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", decodedString);
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        bodyCellSpan({ row, column, rowIndex }) {
            if (column.field === "acwName") {
                // console.log(rowIndex);
                // this.spanNum.push(rowIndex)
                // this.spanValue.push(row.acwId)
                // console.log(this.spanNum,this.spanValue);
                // if(rowIndex > 0 && row.acwId != this.spanValue[rowIndex -1]){
                //     console.log(this.spanNum[0],rowIndex);
                //     this.$set(this,'spanNum',[])
                // }
                // console.log(this.DetailArr.ajClothesApplyItemList.length);
                // if(rowIndex === this.DetailArr.ajClothesApplyItemList.length-1){
                //     this.$set(this,'spanNum',[])
                //     this.$set(this,'spanValue',[])
                // }
            }
        },
        OneKeyExchange() {
            if (this.selectedRowKeysCollection2.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
                return
            }
            this.$confirm("是否确定要交换, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjClothesApplyItemExchangeInside({ acaiIdOne: this.selectedRowKeysCollection2[0], acaiIdTwo: this.selectedRowKeysCollection2[1] }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "新增成功!",
                            });
                            this.selectedRowKeysCollection2 = [];
                            this.checkboxOption2.disableSelectedRowKeys = [];
                            this.openLoading()
                            getAjClothesOrderPreconditioningExchange({ acoId: this.formDD.acoId }).then(res => {
                                this.OrderList = res.data;
                                this.loadings.close()
                            })
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleWorkDDClose() {
            this.formDD = {
                acoId: '',
                acoTitle: '',
                acoDate: '',
            };
            this.selectedRowKeysCollection2 = [];
            this.IsOrder = false;
        },
        sureworkDD() {
            this.$confirm("是否确定要新增, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var newForm = JSON.parse(JSON.stringify(this.formDD));
                    addAjClothesOrderExchange(newForm).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "新增成功!",
                            });
                            this.handleWorkDDClose()
                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        ReturnLook(row) {
            this.formDD.acoId = row.acoId;
            this.openLoading()
            getAjClothesOrderPreconditioningExchange({ acoId: row.acoId }).then(res => {
                this.OrderList = res.data;
                this.IsOrder = true;
                this.loadings.close()
            })
        },
        handleReceiveClose() {
            this.IsReceive = false;
            this.ReceiveData = [];
        },
        handleWorkReturnClose() {
            this.GgAcwsId = '';
            this.RForm.acaiId = '';
            this.isReturn = false;

        },
        sureWorkReturn() {
            this.$confirm("是否确定要换货吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjClothesApplyItemExchange({ acaiId: this.RForm.acaiId, acwsId: this.GgAcwsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.handleWorkReturnClose()
                            this.getUserDetailList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        returnClick(row) {
            this.workGgArr = [{acwsId:0,acwsName:'不需要'}]
            this.RForm.acaiId = row.acaiId
            getAjClothesWareScaleList({ acwId: row.acwId }).then(res => {
                this.workGgArr.push(...res.data);
                this.isReturn = true;
            })
        },
        getUserDetailList() {
            getAjClothesOrderDetails({ acoId: this.acwId }).then(res => {
                this.DetailArr = res.data;
                getAjClothesApplyDetails(this.userForm).then(res => {
                    this.userDetail = res.data;
                })
            })
        },
        ReceiveClick(row) {
            this.$confirm("是否确定要领取吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    updateAjClothesApplyItemReceive({ acaiId: row.acaiId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });

                            this.getUserDetailList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getUserDetail(id) {
            this.userForm.acaId = id.acaId;
            this.userForm.acoId = this.DetailArr.acoId;
            getAjClothesApplyDetails(this.userForm).then(res => {
                this.userDetail = res.data;
                this.isUserDetail = true;
            })
        },
        deliverClick(row) {
            this.DForm.acoId = row.acoId;
            this.IsDeliver = true;
        },
        purchaseClick(row) {
            this.PForm.acoId = row.acoId;
            this.IsPurchase = true;
        },
        handleWorkGgDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjClothesWareScale({ acwsId: row.acwsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.getDetailList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleWorkGgEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.formGg = data;
            this.workEdit = true;
            this.WorkGgShow = true
        },
        handleWorkGgClose() {
            this.formGg.acwsName = '';
            this.workEdit = false;
            this.WorkGgShow = false;

        },
        handleWorkPurchaseClose() {
            this.PForm = {
                acoId: '',
                acoBuyDate: '',
                acoBuyNum: '',
                acoBuyDes: '',
            };
            this.$refs['PForm'].resetFields();
            this.IsPurchase = false;

        },
        handleWorkDeliverClose() {
            this.DForm = {
                acoId: '',
                acoArrivalDate: '',
            };
            this.$refs['DForm'].resetFields();
            this.IsDeliver = false;

        },
        sureworkDeliver() {
            this.$confirm("是否确定已经到货, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var newForm = JSON.parse(JSON.stringify(this.DForm));
                    updateAjClothesOrderArrival(newForm).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.handleWorkDeliverClose()
                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        sureworkPurchase() {
            this.$confirm("是否确定要购买, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var newForm = JSON.parse(JSON.stringify(this.PForm));
                    updateAjClothesOrderToBuy(newForm).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "新增成功!",
                            });
                            this.handleWorkPurchaseClose()
                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        sureworkGg() {
            if (!this.workEdit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        var newForm = JSON.parse(JSON.stringify(this.formGg));
                        addAjClothesWareScale(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleWorkGgClose()
                                this.getDetailList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        var newForm = JSON.parse(JSON.stringify(this.formGg));
                        updateAjClothesWareScale(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleWorkGgClose()
                                this.getDetailList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        getDetail(id) {
            this.acwId = this.formGg.acoId = id
            getAjClothesOrderDetails({ acoId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
            })
        },

        getDetailList() {
            getAjClothesWareDetails({ acwId: this.acwId }).then(res => {
                this.DetailArr = res.data;
                getAjClothesWareScaleList({ acwId: this.acwId }).then(res => {
                    this.workClothesGg = res.data
                })
            })
        },
        removeAfter(file) {
            const url = this.form.acwImages.findIndex(item => item === file)
            this.form.acwImages.splice(url, 1)
        },
        // 上传图片
        fileChange(file) {
            if (this.form.acwImages && this.form.acwImages.length > 0) {
                this.form.acwImages.push(...file)
            } else {
                this.$set(this.form, 'acwImages', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out(command) {
            console.log(command);
            if (this.selectedRowKeysCollection.length == 0 && !command) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && !command) {
                console.log('开始导出', this.selectedRowKeysCollection)
                const bulkdata = {
                    exportType: 2,
                    acwIds: this.selectedRowKeysCollection.toString(),
                    ...this.formDatas
                }
                var s = qs.stringify(bulkdata);
                this.openLoading()
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/aj-purchase-gift/exportAjPurchaseGift',
                    data: s,
                    // withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('userid'),
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '工装.xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            } else {
                const bulkdata = {
                    exportType: 1,
                    ...this.formDatas
                }
                var s = qs.stringify(bulkdata);
                this.openLoading()
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/aj-purchase-gift/exportAjPurchaseGift',
                    data: s,
                    // withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('userid')
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '工装.xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            }
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjClothesWare({ acwId: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjClothesWare({ acwId: row.acwId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.acwImages = data.acwImages ? data.acwImages.split(',') : '';
                if (this.form.acwImages.length > 0) {
                    this.form.acwImages.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img)
                    })
                }
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        var newForm = JSON.parse(JSON.stringify(this.form));
                        console.log(newForm)
                        newForm.acwImages = newForm.acwImages.length > 0 ? newForm.acwImages.filter(item => typeof item === 'string').join(',') : '';
                        addAjClothesWare(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        var newForm = JSON.parse(JSON.stringify(this.form));
                        console.log(newForm)
                        newForm.acwImages = newForm.acwImages.length > 0 ? newForm.acwImages.filter(item => typeof item === 'string').join(',') : '';
                        updateAjClothesWare(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.fileList = [];
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.acwId = row.acwId
                    console.log(jsonObj);
                    updateAjClothesWare(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {
            const rowKey = row[key];
            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption2.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        changeSelectedRowKeys2(row, isSelected, key) {
            console.log(row, isSelected, key);
            const rowKey = row[key];
            const arr = JSON.parse(JSON.stringify(this.OrderList.ajClothesApplyItemDetailsList))
            const tableArr = [];
            arr.map((item, index) => {
                tableArr.push(item.acaiId)
            });
            if (isSelected) {
                this.checkboxOption2.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection2.push(rowKey);
                this.selectedRowKeysCollection2.forEach((item, index) => {
                    if (item && this.selectedRowKeysCollection2.length <= 2) {
                        const index1 = tableArr.indexOf(item);
                        tableArr.splice(index1, 1);
                    }
                })
                if (this.selectedRowKeysCollection2.length == 2) {
                    this.disabled_arr = [];
                    tableArr.map((item, index) => {
                        this.disabled_arr.push(item);
                    })
                    this.checkboxOption2.disableSelectedRowKeys = this.disabled_arr
                }
                console.log(this.checkboxOption2.selectedRowKeys, this.selectedRowKeysCollection2, tableArr);
            } else if (!isSelected && rowKey) {
                const index = this.checkboxOption2.selectedRowKeys.indexOf(rowKey);
                console.log(index);
                if (index != -1) {
                    this.checkboxOption2.selectedRowKeys.splice(index, 1);
                    this.selectedRowKeysCollection2.splice(index, 1);
                    this.checkboxOption2.disableSelectedRowKeys = []
                }

            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjClothesOrderList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.IsDetail = false;
            this.formDatas.currentPage = 1;
            getAjClothesOrderList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjClothesOrderList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.OrderDia .el-card__body,
.el-main {
    padding: 10px !important;
}

.OrderDia .el-form-item {
    margin-bottom: 0 !important;
}

.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>